module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-24.57c7abe3.png";